import i18next from 'i18next';
import { initReactI18next } from 'react-i18next';
// EN
import { ERROR_EN, HOMEPAGE_EN, LOGIN_EN, NAVIGATION_BAR_EN, TABLE_EN} from '@i18n';
// PT
import { ERROR_PT, HOMEPAGE_PT, LOGIN_PT, NAVIGATION_BAR_PT, TABLE_PT} from '@i18n';

const resources = {
  en: {
    translation: { ...ERROR_EN, ...HOMEPAGE_EN, ...NAVIGATION_BAR_EN, ...TABLE_EN, ...LOGIN_EN }
  },
  pt: {
    translation: { ...ERROR_PT, ...HOMEPAGE_PT, ...NAVIGATION_BAR_PT, ...TABLE_PT, ...LOGIN_PT }
  }
};

i18next.use(initReactI18next).init({
  resources,
  lng: 'en',
  supportedLngs: ['en', 'pt'],
  interpolation: {
    escapeValue: false
  }
});

export default i18next;
